import React from 'react';
import { Check } from 'lucide-react';
import { useFadeIn } from '../hooks/useFadeIn';
export function Services() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  const services = [{
    id: 1,
    title: 'Mini Diseño de Sonrisa',
    price: '',
    icon: '💎',
    description: 'La manera más rápida de transformar tu sonrisa con resina de alta estética',
    benefits: ['Cambio en 1 semana', 'Durabilidad 3-5 años', 'Sin dolor']
  }, {
    id: 2,
    title: 'Diseño de Sonrisa en Resina',
    price: '',
    icon: '⭐',
    description: 'Diseño natural con material de alta estética y durabilidad garantizada',
    benefits: ['Durabilidad 3-7 años', 'Color a tu elección', 'Resultado en 1 semana']
  }, {
    id: 3,
    title: 'Diseño Sonrisa Estratificado',
    price: '$4.200.000 COP',
    icon: '🔬',
    description: 'Técnica directa con 8 dientes superiores, incluye kit completo de transformación',
    benefits: ['Limpieza profunda incluida', '3 sesiones de blanqueamiento', 'Kit de aseo diseño incluido']
  }, {
    id: 4,
    title: 'Diseño en Cerámica Dental',
    price: '$9.900.000 COP',
    icon: '👑',
    description: 'Disilicato de litio, el mejor material del mercado. Resultado completamente natural y permanente',
    benefits: ['Durabilidad 15-20 años', 'No se mancha ni fractura', 'Resultado completamente natural']
  }, {
    id: 5,
    title: 'Blanqueamiento Dental',
    price: '$800.000 COP',
    icon: '✨',
    description: 'Procedimiento estético para un blanco natural y radiante en una sola cita',
    benefits: ['Limpieza profunda incluida', 'Resultado inmediato', 'Rápido y completamente seguro']
  }, {
    id: 6,
    title: 'Diseño Completo en Cerámica',
    price: '$18.500.000 COP',
    icon: '🏆',
    description: 'Transformación total. 8 dientes superiores + 8 dientes inferiores en el mejor material',
    benefits: ['Placa protectora incluida', 'Kit de aseo premium incluido', 'Material más resistente del mercado']
  }];
  return <section id="servicios" className="py-24 bg-primary" data-id="element-278">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="text-center mb-16" data-id="element-280">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-281">
            Nuestros Tratamientos
          </h2>
          <p className="text-gold text-lg max-w-2xl mx-auto" data-id="element-282">
            Tecnología de última generación para transformar tu sonrisa
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-283">
          {services.map(service => <div key={service.id} className="bg-card rounded-xl p-7 border-t-4 border-gold hover:shadow-[0_0_24px_rgba(201,168,76,0.18)] hover:scale-[1.02] transition-all duration-300 flex flex-col h-full" data-id="element-284">
              <div className="flex items-start justify-between gap-3 mb-4" data-id="element-285">
                <div className="flex items-center gap-3" data-id="element-286">
                  <span className="text-2xl" data-id="element-287">{service.icon}</span>
                  <h3 className="font-serif text-xl text-white font-semibold leading-tight" data-id="element-288">
                    {service.title}
                  </h3>
                </div>
                {service.price && <span className="bg-gold text-primary text-xs font-bold px-3 py-1 rounded-full shadow-lg whitespace-nowrap flex-shrink-0" data-id="element-289">
                    {service.price}
                  </span>}
              </div>

              <p className="text-gray text-sm mb-6 flex-grow" data-id="element-290">
                {service.description}
              </p>

              <ul className="space-y-3 mb-8" data-id="element-291">
                {service.benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-white/90" data-id="element-292">
                    <Check size={16} className="text-gold mt-0.5 flex-shrink-0" data-id="element-293" />
                    <span data-id="element-294">{benefit}</span>
                  </li>)}
              </ul>

              <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="w-full block text-center border-2 border-gold text-gold hover:bg-gold hover:text-primary font-semibold py-3 rounded-lg transition-colors mt-auto" data-id="element-295">
                Solicitar Información
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}